import styled, { css } from 'styled-components'

import { Reset } from '@/lib/mixins'

export const NumericKeyboardPortal = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 220;
  display: flex;
  justify-content: center;
  padding: 2rem;
  background-color: ${props => props.theme.color.body};
  touch-action: none;
  user-select: none;
  -webkit-touch-callout: none;
`

export const NumericKeyboardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
  width: 100%;
  max-width: 24rem;
  pointer-events: auto;
  background: ${({ theme }) => theme.color.body};
  touch-action: none;
  user-select: none;
  -webkit-touch-callout: none;
`

export const NumericKeyboardButton = styled.button<{ wide?: boolean }>`
  ${Reset('button')};
  position: relative;
  height: 4.5rem;
  border: 1px solid currentColor;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.75rem;
  font-weight: 500;
  overflow: hidden;
  touch-action: none;
  user-select: none;
  -webkit-touch-callout: none;

  svg {
    height: 2.25rem;
    width: 2.75rem;
    fill: currentColor;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: currentColor;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s;
  }

  &:active::after,
  &:focus-visible::after {
    opacity: 0.05;
  }

  ${props =>
    props.wide &&
    css`
      grid-column: span 2;
    `};
`
